import { CATEGORY, META_DATA } from "../utils/constants";
import { useEffect} from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { handleScrollUp } from "../utils/helpers";
import { useAuth } from "../context/authContext";
import { CreateQuizRegister } from "../components/CreateQuizRegister";
import {CreateQuizNotRegister} from "../components/CreateQuizNotRegister";



const CategoryCreateQuiz = () => {
    const { category } = useParams();
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const isValidCategory = Object.values(CATEGORY).find(categoryName => category === categoryName);
    const { title, description, keywords } = META_DATA?.creator;    

    useEffect(() => {
        localStorage.clear();
        handleScrollUp();
    },[])

    useEffect(() => {
        if (!isValidCategory) {
            navigate("/");
        }
    }, [category, isValidCategory]); 


    return (
        <>
        { isValidCategory &&
        <>            
            <Helmet>
                <title>{title}</title>
                <meta name="keywords" content={keywords} />
                <meta name="description" content={description} />
            </Helmet>


            {isAuthenticated? <CreateQuizRegister/>: <CreateQuizNotRegister />}
                </>}
        </>        
    )
};

export default CategoryCreateQuiz;